// extracted by mini-css-extract-plugin
export default {"label":"_1fb00b78"};